module.exports = "/_next/static/images/807e715a2dcc2080861a96e3564d312d-man-holding-device-2@2x.jpg";